// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/PicCenterOutlined";
import AntdIcon from '../components/AntdIcon';

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicCenterOutlinedSvg
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
export default React.forwardRef(PicCenterOutlined);